import { z } from 'zod';
import { CARPET_PRICING_CATEGORIES, CARPET_KEY_REGEX } from '../types/carpetPricingCatalog';

const pricingModeSchema = z.enum(['qty_rate', 'amount']);
const unitLabelSchema = z
  .string()
  .trim()
  .max(32)
  .transform((s) => (s === '' ? null : s))
  .nullable();

export const carpetPricingCatalogCreateSchema = z.object({
  label: z.string().min(1),
  category: z.enum(CARPET_PRICING_CATEGORIES),
  defaultRate: z.number().min(0),
  pricingMode: pricingModeSchema.optional(),
  unitLabel: unitLabelSchema.optional(),
  sortOrder: z.number().int().optional(),
});

export const carpetPricingCatalogUpdateSchema = z.object({
  label: z.string().min(1).optional(),
  category: z.enum(CARPET_PRICING_CATEGORIES).optional(),
  defaultRate: z.number().min(0).optional(),
  pricingMode: pricingModeSchema.optional(),
  unitLabel: unitLabelSchema.optional(),
  sortOrder: z.number().int().optional(),
});

export type CarpetPricingCatalogCreate = z.infer<typeof carpetPricingCatalogCreateSchema>;
export type CarpetPricingCatalogUpdate = z.infer<typeof carpetPricingCatalogUpdateSchema>;

export { CARPET_KEY_REGEX };
